module.exports = __webpack_public_path__ + "static/media/devpost-logo.f614b2f0.svg";